/**
 * © 2024 Little Shilling, Inc. All rights reserved.
 * Shon Little
 * Created: 2024-01-16
 * Updated: 2024-06-19
 */

// Add third-party dependencies.
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

// Add local dependencies.
import Themes from '../../themes';
import Header from './Header';
import Router from '../App/Router';
import Footer from './Footer';

/**
 * Layout component.
 * @example
 * return (
 *   <Layout />
 * )
 * @returns {React.ReactElement} component.
 */
const Layout = () => {
  const location = useLocation();

  // Check if current route is a standalone page (no header/footer)
  const isStandalonePage = location.pathname === '/darby-talent-show';

  // Render component. SessionTimeoutWarning is mounted inside PrivateRoute so it only runs on
  // authenticated pages, not the public site.
  return (
    <Themes>
      <Box sx={{ display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
        {!isStandalonePage && <Header />}
        <Box component="main" sx={{ display: 'flex', flex: 1 }}>
          <Router />
        </Box>
        {!isStandalonePage && <Footer />}
      </Box>
    </Themes>
  );
};

// Export component.
export default Layout;
